var globalWrapper = (typeof window !== "undefined" ? window : this);
if (!("fshr" in globalWrapper)) {
    globalWrapper.fshr = {};
}
globalWrapper.fshr.resizeTimeout = 0;
globalWrapper.fshr.arrowAnimateTimeout = 0;

(function ($, global) {


    /**
     * keycodes
     * */
    var KEYCODE_ARROWLEFT = 37;
    var KEYCODE_ARROWRIGHT = 39;
    var KEYCODE_ESC = 27;


    /**
     * css class only for javascript handling
     * */
    var CLASS_JS_GALLERY = "js-gallery";
    var CLASS_JS_INITIALIZED = "js-gallery-initialized";
    var CLASS_JS_GENERATED = "js-gallery-generated";
    var CLASS_JS_INITIALIZED_GENERATED = "js-gallery-initializedGenerated";
    var CLASS_JS_CLOSE = "js-gallery-close";
    var CLASS_JS_OPEN = "js-gallery-open";
    var CLASS_JS_FILTERITEM = "js-gallery-filter-item";
    var CLASS_JS_SHOWHIDE_THUMBNAILS = "js-gallery-showhide-thumbnails";

    var CLASS_JS_HEADER = "js-gallery-header";
    var CLASS_JS_FOOTER = "js-gallery-footer";
    var CLASS_JS_FILTER = "js-gallery-filter";

    var CLASS_JS_VIEWPORT = "js-gallery-viewport";
    var CLASS_JS_VIEWPORTEDGE = "js-gallery-viewport-edge";
    var CLASS_JS_VIEWPORTITEM = "js-gallery-viewport-item";
    var CLASS_JS_VIEWPORTITEM_DESCRIPTION = "js-gallery-viewport-item-description";
    var CLASS_JS_VIEWPORTITEM_WRAPPER = "js-gallery-viewport-item-wrapper";

    var CLASS_JS_THUMBNAIL = "js-gallery-thumbnail";
    var CLASS_JS_THUMBNAIL_ACTIVEBAR = "js-gallery-thumbnail-active-bar";
    var CLASS_JS_THUMBNAIL_WRAPPER = "js-gallery-thumbnail-wrapper";
    var CLASS_JS_THUMBNAIL_ITEMS = "js-gallery-thumbnail-items";
    var CLASS_JS_THUMBNAIL_ITEMACTIVE = "js-gallery-thumbnail-item-active";
    var CLASS_JS_THUMBNAIL_SCROLLBAR = "js-gallery-thumbnail-scrollbar";
    var CLASS_JS_THUMBNAIL_SCROLLBARBAR = "js-gallery-thumbnail-scrollbar-bar";

    var CLASS_JS_CONTROL = "js-gallery-control";
    var CLASS_JS_CONTROL_NEXT = "js-gallery-control-next";
    var CLASS_JS_CONTROL_PREVIOUS = "js-gallery-control-previous";
    var CLASS_JS_CONTROL_DISABLED = "js-control-disabled";

    var CLASS_JS_MOVABLE_GALLERY = "js-gallery-movable";
    var CLASS_JS_MOVABLE_BAR = "js-bar-movable";
    var CLASS_JS_MOVABLE_THUMBNAIL = "js-thumbnail-movable";
    var CLASS_JS_MOVABLE_PREVIEW = "js-preview-movable";

    var CLASS_JS_MOVESTART_THUMBNAIL = "js-thumbnail-move-start";
    var CLASS_JS_MOVESTART_VIEWPORT = "js-viewport-move-start";


    /**
     * css class only for styling
     * */
    var CLASS_CSS_GALLERY = "fshr-gallery";
    var CLASS_CSS_FULLSCREEN = "fshr-gallery-fullscreen";
    var CLASS_CSS_FIXED = "fshr-gallery-fixedmaximized";
    var CLASS_CSS_NOTANIMATED = "fshr-not-animated";
    var CLASS_CSS_FAKEHOVER = "fshr-fake-hover";
    var CLASS_CSS_FIRSTCHILD = "fshr-first-child";

    var CLASS_CSS_FOOTER = "fshr-gallery-footer";
    var CLASS_CSS_HEADER = "fshr-gallery-header";
    var CLASS_CSS_CLOSE = "fshr-gallery-close";
    var CLASS_CSS_TITLE = "fshr-gallery-title";

    var CLASS_CSS_CONTROL = "fshr-gallery-control";
    var CLASS_CSS_CONTROLITEM = "fshr-gallery-control-item";
    var CLASS_CSS_CONTROLPREVIOUS = "fshr-gallery-control-previous";
    var CLASS_CSS_CONTROLNEXT = "fshr-gallery-control-next";

    var CLASS_CSS_HIDDEN = "fshr-gallery-hidden";
    var CLASS_CSS_ITEMINACTIVE = "fshr-gallery-item-inactive";

    var CLASS_CSS_VIEWPORT = "fshr-gallery-viewport";
    var CLASS_CSS_VIEWPORT_EDGE = "fshr-gallery-viewport-edge";
    var CLASS_CSS_VIEWPORT_NODESCRIPTION = "fshr-gallery-viewport-no-description";
    var CLASS_CSS_VIEWPORTITEM = "fshr-gallery-viewport-item";
    var CLASS_CSS_VIEWPORTITEM_WRAPPER = "fshr-gallery-viewport-item-wrapper";
    var CLASS_CSS_VIEWPORTITEM_DESCRIPTION = "fshr-gallery-viewport-item-description";

    var CLASS_CSS_VIDEO = "fshr-gallery-video";

    var CLASS_CSS_FILTER = "fshr-gallery-filter";
    var CLASS_CSS_FILTER_ITEM = "fshr-gallery-filter-item";
    var CLASS_CSS_FILTER_ITEMNUMBER = "fshr-gallery-filter-item-number";
    var CLASS_CSS_FILTER_ITEMACTIVE = "fshr-gallery-filter-item-active";

    var CLASS_CSS_THUMBNAIL = "fshr-gallery-thumbnail";
    var CLASS_CSS_THUMBNAIL_SCROLLBAR = "fshr-gallery-thumbnail-scrollbar";
    var CLASS_CSS_THUMBNAIL_SCROLLBARBAR = "fshr-gallery-thumbnail-scrollbar-bar";
    var CLASS_CSS_THUMBNAIL_SCROLLBARDISABLED = "fshr-gallery-thumbnail-scrollbar-disabled";
    var CLASS_CSS_THUMBNAIL_UNFILTERED = "fshr-gallery-thumbnail-unfiltered";
    var CLASS_CSS_THUMBNAIL_ITEM = "fshr-gallery-thumbnail-item";
    var CLASS_CSS_THUMBNAIL_ITEMS = "fshr-gallery-thumbnail-items";
    var CLASS_CSS_THUMBNAIL_ITEMVIDEO = "fshr-gallery-thumbnail-item-video";
    var CLASS_CSS_THUMBNAIL_ITEMWRAPPER = "fshr-gallery-thumbnail-item-wrapper";
    var CLASS_CSS_THUMBNAIL_ITEMACTIVE = "fshr-gallery-thumbnail-item-active";
    var CLASS_CSS_THUMBNAIL_ITEMACTIVEBAR = "fshr-gallery-thumbnail-item-active-bar";
    var CLASS_CSS_THUMBNAILS_SHOWHIDE = "fshr-gallery-showhide-thumbnails";


    /**
     * custom events
     * */
    var EVENT_GALLERY_INITIALIZED = "gallery-initialized";
    var EVENT_GALLERY_GENERATED = "gallery-generated";
    var EVENT_GALLERY_AFTEROPEN = "gallery-after-open";
    var EVENT_GALLERY_BEFOREOPEN = "gallery-before-open";
    var EVENT_GALLERY_CLOSE = "gallery-close";
    var EVENT_THUMBNAIL_CHANGED = "thumbnail-changed";
    var EVENT_THUMBNAIL_MOVED = "thumbnail-items-moved";


    /**
     * attributes for any gallery settings
     * */
    var ATTR_DATA_FILTERDEFAULT = "data-gallery-default";
    var ATTR_DATA_FILTEREXTENDED = "data-gallery-filter02";
    var ATTR_DATA_CLOSE = "data-gallery-close";
    var ATTR_DATA_FULLSCREEN = "data-gallery-fullscreen";
    var ATTR_DATA_GALLERYSELECTOR = "data-gallery-selector";
    var ATTR_DATA_THUMBNAILTITLESELECTOR = "data-thumbnail-title-selector";
    var ATTR_DATA_CHILDRENSELECTOR = "data-gallery-children-selector";
    var ATTR_DATA_THUMBNAILSELECTOR = "data-gallery-thumbnail-selector";
    var ATTR_DATA_TITLE = "data-gallery-title";
    var ATTR_DATA_THUMBNAILINDEX = "data-gallery-thumbnailindex";
    var ATTR_DATA_GENERATESEPARATELY = "data-gallery-separated";


    var ATTR_DATA_SCROLLBARRATIO = "data-scrollbar-ratio";
    var ATTR_DATA_EVENTSTARTONBAR = "data-gallery-event-bar-start";
    var ATTR_DATA_ACTUALCURSORPOSITION = "data-actual-cursor-position";
    var ATTR_DATA_PARENTWIDTH = "data-parent-width";
    var ATTR_DATA_STARTCURSORLEFTPOSITION = "data-start-cursor-left-position";
    var ATTR_DATA_STARTCURSORTOPPOSITION = "data-start-cursor-top-position";

    /***
     * filters id
     * */
    var FILTER_ID_DEFAULT = 1;
    var FILTER_ID_EXTENDED = 2;


    /**
     * animations, timeout and other timers
     * */
    var DELAY_INITIALIZE_AFTERRESIZE = 100;
    var ANIMATIONS_DURATION = 200;


    /**
     * sizes
     * */
    var MINIMUM_DISTANCE_START_ANIMATE = 30;
    var MOBILE_WIDTH = 400;


    /**
     * texts
     * */
    var TEXT_CLOSE = "Zavřít";
    var TEXT_PREVIOUS = "Předchozí";
    var TEXT_NEXT = "Následující";
    var TEXT_FILTERALL = "videa i fotky";
    var TEXT_FILTERDEFAULT = "fotky";
    var TEXT_FILTEREXTENDED = "videa";


    /**
     * functions
     * */
    function animateThumbnails ($element, newMargin) {
        var $gallery = $element.closest("." + CLASS_JS_GALLERY);
        var $footer = $gallery.find("." + CLASS_JS_FOOTER);
        $footer.stop(true, false);
        $footer.animate({
            marginBottom: newMargin
        }, {
            step: function () {
                setViewportHeight($gallery);
            },
            duration: ANIMATIONS_DURATION
        });
    }
    function setElementTouchMoving ($element, event) {
        $element.addClass(CLASS_JS_MOVABLE_PREVIEW);
        var position = getPosition(event);
        var leftPosition = position.left;
        var topPosition = position.top;
        $element.attr(ATTR_DATA_STARTCURSORLEFTPOSITION, leftPosition);
        $element.attr(ATTR_DATA_STARTCURSORTOPPOSITION, topPosition);
    }
    function setViewportHeight ($gallery) {
        var $galleryHeader = $gallery.find("." + CLASS_JS_HEADER);
        var $galleryFooter = $gallery.find("." + CLASS_JS_FOOTER);
        var $galleryViewport = $gallery.find("." + CLASS_JS_VIEWPORT);

        var galleryHeight = $gallery.outerHeight();
        var galleryTop = $gallery.offset().top;
        var galleryFooterTop = $galleryFooter.length ? $galleryFooter.offset().top : galleryHeight + galleryTop;

        var headerHeight = $galleryHeader.length ? $galleryHeader.outerHeight() : 0;
        var footerHeight = galleryHeight - (galleryFooterTop - galleryTop);

        $galleryViewport.css({
            paddingTop: headerHeight,
            paddingBottom: footerHeight
        });
    }
    function changeImageVideo (src, $viewportItemWrapper) {
        var isImage = !src.match(/https:\/\/((youtu\.be)|(www\.youtube\.com)).*/i);
        $viewportItemWrapper.parent().removeClass(CLASS_CSS_VIDEO);
        var animationSpeedHalf = ANIMATIONS_DURATION / 2;
        if (isImage) {
            var img = new Image();
            img.onload = function () {
                if ($viewportItemWrapper.attr("data-src") == src) {
                    var $newImage = $("<img src='" + src + "' class='" + CLASS_CSS_VIEWPORTITEM + " " + CLASS_JS_VIEWPORTITEM + "'>");
                    $newImage.hide();
                    $viewportItemWrapper.html($newImage[0].outerHTML);
                    $viewportItemWrapper.find("." + CLASS_JS_VIEWPORTITEM).fadeIn(animationSpeedHalf);
                }
            };
            img.src = src;
        } else {
            var srcParts = src.split("/");
            var videoId = srcParts[srcParts.length-1];
            var videoSrc = "https://www.youtube.com/embed/" + videoId;
            var $video = $("<iframe src='" + videoSrc + "' class='" + CLASS_CSS_VIEWPORTITEM + " " + CLASS_CSS_VIDEO + " " + CLASS_JS_VIEWPORTITEM + "' frameborder='0' allowfullscreen></iframe>");
            $video.hide();
            $viewportItemWrapper.html($video[0].outerHTML);
            $viewportItemWrapper.find("." + CLASS_JS_VIEWPORTITEM).fadeIn(animationSpeedHalf);
            $viewportItemWrapper.parent().addClass(CLASS_CSS_VIDEO);
        }
    }
    function handleFiltersItem ($gallery, type) {

        var $galleryThumbnails = $gallery.find("." + CLASS_JS_THUMBNAIL_WRAPPER);
        var $galleryThumbnailItems = $galleryThumbnails.closest("." + CLASS_JS_THUMBNAIL_ITEMS);
        $galleryThumbnails.removeClass(CLASS_CSS_THUMBNAIL_UNFILTERED + " " + CLASS_CSS_FIRSTCHILD);
        var $itemsFilterDefault = $galleryThumbnails.filter(":not([" + ATTR_DATA_FILTEREXTENDED + "])");
        var $itemsFilterExtended = $galleryThumbnails.filter("[" + ATTR_DATA_FILTEREXTENDED + "]");
        var $activeItem = $galleryThumbnails.filter("." + CLASS_JS_THUMBNAIL_ITEMACTIVE);
        var thumbnailsChanged = false;

        if (type) {
            var $itemsToHide = $();
            var $itemsToShow = $();
            var activeSelector = "";
            switch (type) {
                case FILTER_ID_EXTENDED:
                    $itemsToHide = $itemsFilterDefault;
                    $itemsToShow = $itemsFilterExtended;
                    activeSelector = "[" + ATTR_DATA_FILTEREXTENDED + "]";
                break;
                case FILTER_ID_DEFAULT:
                    $itemsToHide = $itemsFilterExtended;
                    $itemsToShow = $itemsFilterDefault;
                    activeSelector = ":not([" + ATTR_DATA_FILTEREXTENDED + "])";
                break;
            }

            $itemsToHide.addClass(CLASS_CSS_THUMBNAIL_UNFILTERED);
            $itemsToHide.first().addClass(CLASS_CSS_FIRSTCHILD);
            $gallery.each(initializeGallery);
            if (!$activeItem.is(activeSelector)) {
                $itemsToShow.first().find("a." + CLASS_JS_THUMBNAIL).trigger("click");
            } else {
                thumbnailsChanged = true;
            }
        } else {
            $gallery.each(initializeGallery);
            thumbnailsChanged = true;
        }

        if (thumbnailsChanged) {
            $galleryThumbnailItems.trigger(EVENT_THUMBNAIL_CHANGED, {
                gallery: $gallery,
                anchor: $activeItem.find("." + CLASS_JS_THUMBNAIL),
                anchorWrapper: $activeItem
            });
        }
    }
    function initializeThumbnailItems () {
        var $this = $(this);
        var $items = $this.find("." + CLASS_JS_THUMBNAIL_WRAPPER + ":visible");
        var totalWidth = 0;
        var itemsCount = $items.length;
        var $controls = $this.closest("." + CLASS_JS_GALLERY).find("." + CLASS_JS_CONTROL);
        $controls.show();
        if (itemsCount < 2) {
            $controls.hide();
        }
        $items.each(function () {
            var $item = $(this);
            totalWidth = totalWidth + $item.outerWidth();
        });
        $this.css({
            width: totalWidth
        });
    }
    function initializeThumbnailScrollbar () {
        var $scrollbar = $(this);
        var $thumbnail = $scrollbar.closest("." + CLASS_JS_THUMBNAIL);
        var $thumbnailItems = $thumbnail.find("." + CLASS_JS_THUMBNAIL_ITEMS);

        var thumbnailWidth = $thumbnail.outerWidth();
        var thumbnailItemsWidth = $thumbnailItems.outerWidth();
        var thumbnailItemsLeft = $thumbnailItems.position().left;
        var scrollbarWidth = $scrollbar.outerWidth();

        var scrollbarRatio = thumbnailItemsWidth / scrollbarWidth;

        if (scrollbarRatio > 1) {
            $scrollbar.removeClass(CLASS_CSS_THUMBNAIL_SCROLLBARDISABLED);
            var $scrollbarBar = $scrollbar.find("." + CLASS_JS_THUMBNAIL_SCROLLBARBAR);

            $thumbnailItems.attr(ATTR_DATA_SCROLLBARRATIO, scrollbarRatio);
            $scrollbarBar.attr(ATTR_DATA_SCROLLBARRATIO, scrollbarRatio);

            var scrollbarBarWidth = thumbnailWidth / scrollbarRatio;
            $scrollbarBar.css({
                left: Math.abs(thumbnailItemsLeft) / scrollbarRatio,
                width: scrollbarBarWidth
            });
        } else {
            $scrollbar.addClass(CLASS_CSS_THUMBNAIL_SCROLLBARDISABLED);
        }
    }
    function setTitle ($thumbnail, $gallery) {
        var titleSelector = $thumbnail.attr(ATTR_DATA_THUMBNAILTITLESELECTOR);
        var $titleElement = global.getElementsBySelector(titleSelector, $thumbnail);
        var title = "";
        var titleAttr = $thumbnail.attr("title");
        if ($titleElement.length) {
            title = $titleElement.html();
        } else if (titleAttr) {
            title = titleAttr;
        }

        var $title = $gallery.find("." + CLASS_JS_VIEWPORTITEM_DESCRIPTION);
        var animationSpeedHalf = ANIMATIONS_DURATION/2;
        if (title.length) {
            $title.stop(true, true);
            $title.animate({
                marginTop: 0
            }, {
                duration: animationSpeedHalf,
                complete: function () {
                    if ($title.hasClass(CLASS_CSS_VIEWPORT_NODESCRIPTION)) {
                        $title.removeClass(CLASS_CSS_VIEWPORT_NODESCRIPTION);
                    }
                    $title.html(title);
                    $title.animate({
                        marginTop: -$title.outerHeight()
                    }, {
                        duration: animationSpeedHalf
                    })
                }
            });
        } else {
            if (!$title.hasClass(CLASS_CSS_VIEWPORT_NODESCRIPTION)) {
                $title.animate({
                    marginTop: 0
                }, {
                    duration: animationSpeedHalf,
                    complete: function () {
                        $title.addClass(CLASS_CSS_VIEWPORT_NODESCRIPTION);
                    }
                });
            }
        }
    }
    function initializeGallery () {
        var $gallery = $(this);

        if (!$gallery.is("[data-gallery-map]")) {
            var $thumbnailItems = $gallery.find("." + CLASS_JS_THUMBNAIL_ITEMS);
            $thumbnailItems.each(initializeThumbnailItems);

            var $thumbnailScrollbar = $gallery.find("." + CLASS_JS_THUMBNAIL_SCROLLBAR);
            $thumbnailScrollbar.each(initializeThumbnailScrollbar);
        }

        if ($gallery.is("[" + ATTR_DATA_FULLSCREEN + "]")) {
            setViewportHeight($gallery);
        }

        $gallery.addClass(CLASS_JS_INITIALIZED);
        $gallery.trigger(EVENT_GALLERY_INITIALIZED);
    }
    function setActiveBarPosition ($gallery, $anchor, $anchorWrapper) {
        var anchorLeftPosition = $anchorWrapper.position().left + $anchor.position().left;
        var $activeBar = $gallery.find("." + CLASS_JS_THUMBNAIL_ACTIVEBAR);
        $activeBar.css({
            left: anchorLeftPosition
        });
    }
    function getPosition (event) {
        var touch = event.originalEvent;
        var positionLeft = event.clientX;
        var positionTop = event.clientY;
        if (touch) {
            var touches = event.originalEvent.touches;
            if (touches && touches.length == 1) {
                touch = touches[0];
            }
            positionLeft = touch.pageX;
            positionTop = touch.pageY;
        }
        return {
            left: positionLeft,
            top: positionTop
        };
    }
    function setThumbnailsMargin ($gallery) {
        var $galleryFooter = $gallery.find("." + CLASS_JS_FOOTER);
        var $galleryThumbnailShowHide = $galleryFooter.find("." + CLASS_JS_SHOWHIDE_THUMBNAILS);
        var galleryFooterHeight = $galleryFooter.outerHeight();
        var galleryThumbnailShowHideHeight = $galleryThumbnailShowHide.outerHeight();
        var marginBottom = 0;
        if ($galleryThumbnailShowHide.hasClass(CLASS_CSS_ITEMINACTIVE)) {
            marginBottom = galleryThumbnailShowHideHeight - galleryFooterHeight;
        }
        $galleryFooter.css({
            marginBottom: marginBottom
        });

    }
    function generateGallery () {
        var $gallery = $(this);
        var generateSeparately = $gallery.is("[" + ATTR_DATA_GENERATESEPARATELY + "]");
        var isMapGallery = $gallery.is("[data-gallery-map]");
        if (generateSeparately) {
            var $originalGallery = $gallery;
            $gallery = $gallery.clone();
            $gallery.removeAttr("class");
        }
        var $window = $(window);
        var viewportWidth= $window.outerWidth();
        var isMobileWidth = viewportWidth < MOBILE_WIDTH;
        $gallery.addClass(CLASS_JS_GALLERY);

        var itemsSelector = $gallery.attr(ATTR_DATA_CHILDRENSELECTOR);
        var thumbnailSelector = $gallery.attr(ATTR_DATA_THUMBNAILSELECTOR);
        var galleryTitle = $gallery.attr(ATTR_DATA_TITLE);
        var galleryClose = $gallery.is("[" + ATTR_DATA_CLOSE + "]");

        var $items = $gallery.children();
        if (itemsSelector) {
            $items = $gallery.find(itemsSelector);
        }
        var $originalItems = $();
        if (generateSeparately) {
            $originalItems = $originalGallery.children();
            if (itemsSelector) {
                $originalItems = $originalGallery.find(itemsSelector);
            }
        }

        var $thumbnails = $items.children("a");
        if (thumbnailSelector) {
            $items.find(thumbnailSelector);
        }

        $gallery.addClass(CLASS_CSS_GALLERY);
        if ($gallery.is("[" + ATTR_DATA_FULLSCREEN + "]") || generateSeparately) {
            $gallery.addClass(CLASS_CSS_FULLSCREEN);
        }
        $items.addClass(CLASS_CSS_THUMBNAIL_ITEMWRAPPER + " " + CLASS_JS_THUMBNAIL_WRAPPER);
        $thumbnails.addClass(CLASS_CSS_THUMBNAIL_ITEM + " " + CLASS_JS_THUMBNAIL);

        var $galleryFooter = $("<div class='" + CLASS_CSS_FOOTER + " " + CLASS_JS_FOOTER + "'></div>");
        var $galleryHeader = $("<div class='" + CLASS_CSS_HEADER + " " + CLASS_JS_HEADER + "'></div>");
        var $galleryCloseButton = $("<a class='" + CLASS_CSS_CLOSE + " " + CLASS_JS_CLOSE + "'>" + TEXT_CLOSE + "</a>");
        var $galleryTitle = $("<div class='" + CLASS_CSS_TITLE + "'></div>");

        var $galleryViewportWrapper = $("<div class='" + CLASS_CSS_VIEWPORT + " " + CLASS_JS_VIEWPORT + "'></div>");
        var $galleryViewport = $("<div class='" + CLASS_CSS_VIEWPORT_EDGE + " " + CLASS_JS_VIEWPORTEDGE + "'></div>");
        $galleryViewportWrapper.append($galleryViewport);
        var $galleryViewportItemWrapper = $("<div class='" + CLASS_CSS_VIEWPORTITEM_WRAPPER + " " + CLASS_JS_VIEWPORTITEM_WRAPPER + "'></div>");

        var $galleryControl = $("<div class='" + CLASS_CSS_CONTROL + "'></div>");
        var $galleryControlPrevious = $("<a class='" + CLASS_CSS_CONTROLITEM + " " + CLASS_CSS_CONTROLPREVIOUS + " " + CLASS_JS_CONTROL + " " + CLASS_JS_CONTROL_PREVIOUS + "'>" + TEXT_PREVIOUS + "</a>");
        var $galleryControlNext = $("<a class='" + CLASS_CSS_CONTROLITEM + " " + CLASS_CSS_CONTROLNEXT + " " + CLASS_JS_CONTROL + " " + CLASS_JS_CONTROL_NEXT + "'>" + TEXT_NEXT + "</a>");
        $galleryControl.append($galleryControlPrevious);
        $galleryControl.append($galleryControlNext);

        var $galleryDescription = $("<div class='" + CLASS_CSS_VIEWPORTITEM_DESCRIPTION + " " + CLASS_JS_VIEWPORTITEM_DESCRIPTION + "'></div>");

        var $thumbnail = $("<div class='" + CLASS_CSS_THUMBNAIL + " " + CLASS_JS_THUMBNAIL + "'></div>");
        var $thumbnailActiveMarker = $("<div class='" + CLASS_CSS_THUMBNAIL_ITEMACTIVEBAR + " " + CLASS_JS_THUMBNAIL_ACTIVEBAR + "'></div>");
        var $thumbnailItems = $("<div class='" + CLASS_CSS_THUMBNAIL_ITEMS + " " + CLASS_JS_THUMBNAIL_ITEMS + "'></div>");
        var $thumbnailScrollbar = $("<div class='" + CLASS_CSS_THUMBNAIL_SCROLLBAR + " " + CLASS_JS_THUMBNAIL_SCROLLBAR + "'><div class='" + CLASS_CSS_THUMBNAIL_SCROLLBARBAR + " " + CLASS_JS_THUMBNAIL_SCROLLBARBAR + "'></div></div>");

        if (galleryClose || generateSeparately) {
            $galleryHeader.append($galleryCloseButton);
        }
        if (typeof galleryTitle !== "undefined") {
            $galleryTitle.html(galleryTitle);
        }
        $galleryHeader.append($galleryTitle);

        $galleryViewport.append($galleryViewportItemWrapper);

        if (!isMapGallery) {
            $galleryViewport.append($galleryControl);
            $galleryViewport.append($galleryDescription);

            $thumbnailItems.append($items);
            $thumbnailItems.append($thumbnailActiveMarker);
            $thumbnail.append($thumbnailItems);
            $thumbnail.append($thumbnailScrollbar);

            var itemsPhotoCount = $items.filter(":not([" + ATTR_DATA_FILTEREXTENDED + "])").length;

            var $videoItems = $items.filter("[" + ATTR_DATA_FILTEREXTENDED + "]");
            $videoItems.find("." + CLASS_JS_THUMBNAIL).addClass(CLASS_CSS_THUMBNAIL_ITEMVIDEO);
            var itemsVideoCount = $videoItems.length;
            var itemsAllCount = $items.length;

            var cssClassThumbnailsActivity = "";
            if (isMobileWidth) {
                cssClassThumbnailsActivity = " " + CLASS_CSS_ITEMINACTIVE;
            }
            var $galleryThumbnailShowHide = $("<a href='#' class='" + CLASS_JS_SHOWHIDE_THUMBNAILS +" " + CLASS_CSS_THUMBNAILS_SHOWHIDE + cssClassThumbnailsActivity + "'></a>");
            if (!isMapGallery) {
                $galleryFooter.append($galleryThumbnailShowHide);
            }

            if (itemsVideoCount && itemsPhotoCount) {
                var $thumbnailFilters = $("<div class='" + CLASS_CSS_FILTER + " " + CLASS_JS_FILTER + "'></div>");
                var $filterItemAll = $("<a href='#' class='" + CLASS_CSS_FILTER_ITEM + " " + CLASS_JS_FILTERITEM + "'>" + TEXT_FILTERALL + " <span class='" + CLASS_CSS_FILTER_ITEMNUMBER + "'>" + itemsAllCount +"</span></a>");
                var $filterItemPhoto = $("<a href='#' class='" + CLASS_CSS_FILTER_ITEM + " " + CLASS_JS_FILTERITEM + "' " + ATTR_DATA_FILTERDEFAULT + ">" + TEXT_FILTERDEFAULT + " <span class='" + CLASS_CSS_FILTER_ITEMNUMBER + "'>" + itemsPhotoCount +"</span></a>");
                var $filterItemVideo = $("<a href='#' class='" + CLASS_CSS_FILTER_ITEM + " " + CLASS_JS_FILTERITEM + "' " + ATTR_DATA_FILTEREXTENDED + ">" + TEXT_FILTEREXTENDED + " <span class='" + CLASS_CSS_FILTER_ITEMNUMBER + "'>" + itemsVideoCount +"</span></a>");

                $filterItemAll.addClass(CLASS_CSS_FILTER_ITEMACTIVE);

                $thumbnailFilters.append($filterItemAll);
                $thumbnailFilters.append($filterItemPhoto);
                $thumbnailFilters.append($filterItemVideo);
                $galleryFooter.append($thumbnailFilters);
            }

            if (!isMapGallery) {
                $galleryFooter.append($thumbnail);
            }
        } else {
            var $map = $gallery.find(".js-gallery-map");
            $galleryViewportItemWrapper.append($map);
        }


        if (galleryClose || generateSeparately || typeof galleryTitle !== "undefined") {
            $gallery.append($galleryHeader);
        }
        $gallery.append($galleryViewportWrapper);
        if (!isMapGallery) {
            $gallery.append($galleryFooter);
        }

        if (generateSeparately) {
            var originalId = $originalGallery.attr("id");
            var id = originalId + "-separated";
            $gallery.attr("id", id);
            var $originalAnchors = $originalItems.find("a");
            $originalItems.each(function (index) {
                var $anchor = $(this).find("a");
                $anchor.attr(ATTR_DATA_THUMBNAILINDEX, index);
            });
            $originalAnchors.attr(ATTR_DATA_GALLERYSELECTOR, "#" + id);
            $originalAnchors.addClass(CLASS_JS_OPEN);
            $gallery.addClass(CLASS_CSS_HIDDEN + " " + CLASS_CSS_FIXED);
            var $triggerAnchors = $("." + CLASS_JS_OPEN).filter("[href='#" + originalId  + "'], [" + ATTR_DATA_GALLERYSELECTOR + "='#" + originalId + "']");
            $triggerAnchors.attr(ATTR_DATA_GALLERYSELECTOR, "#" + id);
            $("body").append($gallery);
        }

        $gallery.trigger(EVENT_GALLERY_GENERATED);
        $gallery.each(initializeGallery);

        setThumbnailsMargin($gallery);
        $gallery.addClass(CLASS_JS_INITIALIZED_GENERATED);
    }
    function closeGallery ($galleries) {
        $galleries.addClass(CLASS_CSS_HIDDEN);
        $galleries.find("." + CLASS_JS_VIEWPORTITEM).remove();
        $galleries.trigger(EVENT_GALLERY_CLOSE);
    }


    /**
     * events handlers
     * */
    $(document).on("click", "." + CLASS_JS_CONTROL + ":not(." + CLASS_JS_CONTROL_DISABLED + ")", function () {
        var $this = $(this);
        var $gallery = $this.closest("." + CLASS_JS_GALLERY);
        var $thumbnails = $gallery.find("." + CLASS_JS_THUMBNAIL_WRAPPER + ":not(." + CLASS_CSS_THUMBNAIL_UNFILTERED + ")");
        var isNext = $this.hasClass(CLASS_JS_CONTROL_NEXT);
        var activeThumbnailIndex = 0;
        var $activeThumbnail = $();

        for (var thumbnailIndex = 0, thumbnailCount = $thumbnails.length; thumbnailIndex < thumbnailCount; thumbnailIndex++) {
            var $currentThumbnailItem = $($thumbnails[thumbnailIndex]);
            if ($currentThumbnailItem.hasClass(CLASS_JS_THUMBNAIL_ITEMACTIVE)) {
                activeThumbnailIndex = thumbnailIndex;
                $activeThumbnail = $currentThumbnailItem;
            }
        }
        var $newThumbnail = $();

        if (isNext) {
            var $nextThumbnail = $($thumbnails[activeThumbnailIndex + 1]);
            if ($nextThumbnail.length) {
                $newThumbnail = $nextThumbnail.find("a." + CLASS_JS_THUMBNAIL);
            } else {
                $newThumbnail = $thumbnails.eq(0).find("a." + CLASS_JS_THUMBNAIL);
            }
        } else {
            var $previousThumbnail = $($thumbnails[activeThumbnailIndex - 1]);
            if ($previousThumbnail.length) {
                $newThumbnail = $previousThumbnail.find("a." + CLASS_JS_THUMBNAIL);
            } else {
                $newThumbnail = $thumbnails.eq($thumbnails.length-1).find("a." + CLASS_JS_THUMBNAIL);
            }
        }
        $newThumbnail.trigger("click");
    });
    $(document).on("click", "a." + CLASS_JS_THUMBNAIL + ":visible", function (event) {
        event.preventDefault();
        var $anchor = $(this);
        var $anchorWrapper = $anchor.closest("." + CLASS_JS_THUMBNAIL_WRAPPER);
        if ($anchorWrapper.length) {
            var $gallery = $anchor.closest("." + CLASS_JS_GALLERY);
            var $viewportItemWrapper = $gallery.find("." + CLASS_JS_VIEWPORTITEM_WRAPPER);
            var $actualViewportItem = $viewportItemWrapper.find("." + CLASS_JS_VIEWPORTITEM);

            var actualSrc = $actualViewportItem.attr("src");
            var newSrc = $anchor.attr("href");
            var $thumbnailItems = $gallery.find("." + CLASS_JS_THUMBNAIL_WRAPPER);
            $thumbnailItems.removeClass(CLASS_CSS_THUMBNAIL_ITEMACTIVE + " " + CLASS_JS_THUMBNAIL_ITEMACTIVE);
            $anchorWrapper.addClass(CLASS_CSS_THUMBNAIL_ITEMACTIVE + " " + CLASS_JS_THUMBNAIL_ITEMACTIVE);

            if (actualSrc !== newSrc) {
                $viewportItemWrapper.attr("data-src", newSrc);
                changeImageVideo(newSrc, $viewportItemWrapper);
            }
            setTitle($anchor, $gallery);
            $anchorWrapper.closest("." + CLASS_JS_THUMBNAIL_ITEMS).trigger(EVENT_THUMBNAIL_CHANGED, {
                gallery: $gallery,
                anchor: $anchor,
                anchorWrapper: $anchorWrapper
            });
        }
    });
    $(document).on(EVENT_THUMBNAIL_CHANGED, "." + CLASS_JS_THUMBNAIL_ITEMS, function (event, data) {
        var $this = $(this);
        var $activeItem = $this.find("." + CLASS_JS_THUMBNAIL_ITEMACTIVE);
        var $galleryThumbnail = $this.closest("." + CLASS_JS_THUMBNAIL);

        var galleryThumbnailWidth = $galleryThumbnail.outerWidth();
        var thumbnailItemsWidth = $this.outerWidth();
        var activeItemWidth = $activeItem.outerWidth();
        var activeItemPositionLeft = $activeItem.position().left;

        var newThumbnailItemsPositionLeft = (galleryThumbnailWidth/2) - (activeItemPositionLeft + (activeItemWidth/2));
        var minimumPositionLeft = galleryThumbnailWidth - thumbnailItemsWidth;
        var maximumPositionLeft = 0;

        if (newThumbnailItemsPositionLeft < minimumPositionLeft) {
            newThumbnailItemsPositionLeft = minimumPositionLeft;
        }
        if (maximumPositionLeft < newThumbnailItemsPositionLeft) {
            newThumbnailItemsPositionLeft = maximumPositionLeft;
        }

        $this.css({
            left: newThumbnailItemsPositionLeft
        });
        var position = {
            left: newThumbnailItemsPositionLeft
        };
        setActiveBarPosition (data.gallery, data.anchor, data.anchorWrapper);
        $.extend(data, position);
        $this.trigger(EVENT_THUMBNAIL_MOVED, data);
    });
    $(document).on(EVENT_THUMBNAIL_MOVED, "." + CLASS_JS_THUMBNAIL_ITEMS, function (event, data) {
        var $this = $(this);
        $("." + CLASS_JS_GALLERY).each(initializeGallery);
        var actualPositionLeft = Math.abs(data.left);
        var scrollbarRatio = parseFloat($this.attr(ATTR_DATA_SCROLLBARRATIO));
        var $scrollbarBar = $this.closest("." + CLASS_JS_THUMBNAIL).find("." + CLASS_JS_THUMBNAIL_SCROLLBARBAR);
        var scrollbarLeft = actualPositionLeft / scrollbarRatio;
        $scrollbarBar.css({
            left: scrollbarLeft
        });
    });
    $(document).on("mousemove mouseup touchend touchmove", function (event) {
        var $thumbnail = $("." + CLASS_JS_GALLERY + ":visible ." + CLASS_JS_THUMBNAIL);
        var $bar = $thumbnail.find("." + CLASS_JS_THUMBNAIL_SCROLLBARBAR + "." + CLASS_JS_MOVABLE_BAR);
        var $thumbnailItems = $thumbnail.find("." + CLASS_JS_THUMBNAIL_ITEMS + "." + CLASS_JS_MOVABLE_THUMBNAIL);
        var $galleryPreviewEdge = $("." + CLASS_JS_GALLERY + ":visible ." + CLASS_JS_VIEWPORTEDGE + "." + CLASS_JS_MOVABLE_PREVIEW);
        var isBar = $thumbnail.is("[" + ATTR_DATA_EVENTSTARTONBAR + "]");

        var eventType = event.type;
        switch (eventType) {
            case "mousemove":
            case "touchmove":
                if ($bar.length || $thumbnailItems.length) {
                    var newCursorPosition = getPosition(event).left;
                    var scrollbarRatio = parseFloat($thumbnailItems.attr(ATTR_DATA_SCROLLBARRATIO));

                    if ($bar.length) {
                        var barPreviousCursorPosition = parseInt($bar.attr(ATTR_DATA_ACTUALCURSORPOSITION), 10);
                        $bar.attr(ATTR_DATA_ACTUALCURSORPOSITION, newCursorPosition);
                        var barPositionDifference = newCursorPosition - barPreviousCursorPosition;
                        var barLeftPosition = $bar.position().left;
                        var newBarLeftPosition = barLeftPosition + barPositionDifference;
                        var minimumBarLeftPosition = 0;
                        var maximumBarLeftPosition = parseInt($bar.attr(ATTR_DATA_PARENTWIDTH), 10) - $bar.outerWidth();

                        if (newBarLeftPosition < minimumBarLeftPosition) {
                            newBarLeftPosition = minimumBarLeftPosition;
                        }
                        if (maximumBarLeftPosition < newBarLeftPosition) {
                            newBarLeftPosition = maximumBarLeftPosition;
                        }

                    }

                    if ($thumbnailItems.length) {
                        var thumbnailItemsPreviousCursorPosition = parseInt($thumbnailItems.attr(ATTR_DATA_ACTUALCURSORPOSITION), 10);
                        $thumbnailItems.attr(ATTR_DATA_ACTUALCURSORPOSITION, newCursorPosition);
                        var thumbnailItemsPositionDifference = thumbnailItemsPreviousCursorPosition - newCursorPosition;
                        var thumbnailItemsLeftPosition = $thumbnailItems.position().left;
                        var newThumbnailItemsLeftPosition = thumbnailItemsLeftPosition - thumbnailItemsPositionDifference;
                        var minimumThumbnailItemsLeftPosition = $thumbnail.width() - $thumbnailItems.outerWidth();
                        var maximumThumbnailItemsLeftPosition = 0;

                        if (newThumbnailItemsLeftPosition < minimumThumbnailItemsLeftPosition) {
                            newThumbnailItemsLeftPosition = minimumThumbnailItemsLeftPosition;
                        }
                        if (maximumThumbnailItemsLeftPosition < newThumbnailItemsLeftPosition) {
                            newThumbnailItemsLeftPosition = maximumThumbnailItemsLeftPosition;
                        }

                    }

                    if (isBar) {
                        newThumbnailItemsLeftPosition = Math.round(newBarLeftPosition * -scrollbarRatio);
                    } else {
                        newBarLeftPosition = Math.round(newThumbnailItemsLeftPosition / -scrollbarRatio);
                    }

                    $bar.css({
                        left: newBarLeftPosition
                    });
                    $thumbnailItems.css({
                        left: newThumbnailItemsLeftPosition
                    });
                }
                if ($galleryPreviewEdge.length) {
                    $galleryPreviewEdge.attr(ATTR_DATA_ACTUALCURSORPOSITION, getPosition(event).left);
                }
            break;
            case "mouseup":
            case "touchend":
                if ($bar.length || $thumbnailItems.length) {
                    $bar.removeClass(CLASS_JS_MOVABLE_BAR);
                    $thumbnailItems.removeClass(CLASS_JS_MOVABLE_THUMBNAIL);
                    $thumbnail.removeClass(CLASS_CSS_NOTANIMATED);
                    $thumbnail.removeAttr(ATTR_DATA_EVENTSTARTONBAR);
                }
                if ($galleryPreviewEdge.length) {
                    var startLeftPosition = parseInt($galleryPreviewEdge.attr(ATTR_DATA_STARTCURSORLEFTPOSITION), 10);
                    var endLeftPosition = parseInt($galleryPreviewEdge.attr(ATTR_DATA_ACTUALCURSORPOSITION), 10);
                    var leftDistance = startLeftPosition - endLeftPosition;
                    var $previewWidth = $galleryPreviewEdge.outerWidth();
                    var distanceEdge = $previewWidth * 0.1;
                    $galleryPreviewEdge.removeClass(CLASS_JS_MOVABLE_PREVIEW);
                    if (Math.abs(leftDistance) >= distanceEdge) {
                        var toPrevious = leftDistance < 0;
                        var $controls = $galleryPreviewEdge.find("." + CLASS_JS_CONTROL);
                        $controls.addClass(CLASS_JS_CONTROL_DISABLED);
                        var $controlToClick = $controls.filter("." + CLASS_JS_CONTROL_NEXT);
                        if (toPrevious) {
                            $controlToClick = $controls.filter("." + CLASS_JS_CONTROL_PREVIOUS);
                        }
                        $controlToClick.removeClass(CLASS_JS_CONTROL_DISABLED);
                        $controlToClick.trigger("click");
                        $galleryPreviewEdge.removeAttr(ATTR_DATA_ACTUALCURSORPOSITION);
                        $galleryPreviewEdge.addClass(CLASS_JS_CONTROL_DISABLED);
                    }
                }
            break;
        }
    });
    $(document).on("mousedown touchstart", "." + CLASS_JS_THUMBNAIL, function (event) {
        var $thumbnail = $(this);
        var $target = $(event.target);
        var $gallery = $thumbnail.closest("." + CLASS_JS_GALLERY);
        var isBar = $target.closest("." + CLASS_JS_THUMBNAIL_SCROLLBARBAR).length;
        var $bar = $thumbnail.find("." + CLASS_JS_THUMBNAIL_SCROLLBARBAR);
        var $thumbnailItems = $thumbnail.find("." + CLASS_JS_THUMBNAIL_ITEMS);
        var leftPosition = getPosition(event).left;

        $thumbnailItems.attr(ATTR_DATA_ACTUALCURSORPOSITION, leftPosition);
        $thumbnailItems.addClass(CLASS_JS_MOVABLE_THUMBNAIL);

        var $barParent = $bar.parent();
        var barParentWidth = $barParent.width();
        $bar.attr(ATTR_DATA_ACTUALCURSORPOSITION, leftPosition);
        $bar.addClass(CLASS_JS_MOVABLE_BAR);
        $bar.attr(ATTR_DATA_PARENTWIDTH, barParentWidth);

        $thumbnail.addClass(CLASS_CSS_NOTANIMATED);
        $gallery.addClass(CLASS_JS_MOVESTART_THUMBNAIL);
        if (isBar) {
            $thumbnail.attr(ATTR_DATA_EVENTSTARTONBAR, "");
        }
    });
    $(document).on("mousedown touchstart", "." + CLASS_JS_VIEWPORTEDGE, function (event) {
        var $galleryPreviewEdge = $(this);
        var $gallery = $galleryPreviewEdge.closest("." + CLASS_JS_GALLERY);
        setElementTouchMoving($galleryPreviewEdge, event);
        $gallery.addClass(CLASS_JS_MOVESTART_VIEWPORT);
        $galleryPreviewEdge.find("." + CLASS_JS_CONTROL).removeClass(CLASS_JS_CONTROL_DISABLED);
    });
    $(document).on("mousedown touchstart", "." + CLASS_JS_GALLERY, function (event) {
        var $element = $(this);
        setElementTouchMoving($element, event);
        $element.addClass(CLASS_JS_MOVABLE_GALLERY);

    });
    $(document).on("mousemove touchmove", "." + CLASS_JS_GALLERY + "." + CLASS_JS_MOVABLE_GALLERY, function (event) {
        var $gallery = $(this);
        if (!$gallery.hasClass(CLASS_JS_MOVESTART_THUMBNAIL)) {
            event.preventDefault();
        }
        var $element = $gallery.find("." + CLASS_JS_SHOWHIDE_THUMBNAILS);
        var $footer = $gallery.find("." + CLASS_JS_FOOTER);
        var currentTopPosition = getPosition(event).top;
        var startPosition = parseInt($gallery.attr(ATTR_DATA_STARTCURSORTOPPOSITION), 10) || 0;
        var positionDifference = currentTopPosition - startPosition;
        var movingDistance = Math.abs(positionDifference);
        var isMovingTop = 0 > positionDifference;

        if (movingDistance > MINIMUM_DISTANCE_START_ANIMATE) {
            var newMargin = 0;
            if (!isMovingTop) {
                var footerHeight = $footer.outerHeight();
                var thisHeight = $element.outerHeight();
                newMargin = thisHeight - footerHeight;
                $element.addClass(CLASS_CSS_ITEMINACTIVE);
            } else {
                $element.removeClass(CLASS_CSS_ITEMINACTIVE);
            }
            $gallery.removeClass(CLASS_JS_MOVABLE_GALLERY);

            animateThumbnails($element, newMargin);
        }
    });
    $(document).on("mouseup touchend", "." + CLASS_JS_GALLERY + "." + CLASS_JS_MOVABLE_GALLERY, function () {
        var $gallery = $(this);
        $gallery.removeClass(CLASS_JS_MOVABLE_GALLERY + " " + CLASS_JS_MOVESTART_THUMBNAIL);
    });
    $(document).on("click", "." + CLASS_JS_SHOWHIDE_THUMBNAILS, function (event) {
        event.preventDefault();
        var $this = $(this);
        var $footer = $this.closest("." + CLASS_JS_FOOTER);
        var newMargin = 0;
        if (!$this.hasClass(CLASS_CSS_ITEMINACTIVE)) {
            var footerHeight = $footer.outerHeight();
            var thisHeight = $this.outerHeight();
            newMargin = thisHeight - footerHeight;
            $this.addClass(CLASS_CSS_ITEMINACTIVE);
        } else {
            $this.removeClass(CLASS_CSS_ITEMINACTIVE);
        }

        animateThumbnails($this, newMargin);
    });
    $(document).on("mousedown touchstart", function (event) {
        var position = getPosition(event);
        global.events = {
            position: position,
            time: new Date().getTime()
        }
    });
    $(document).on("click", "." + CLASS_JS_FILTERITEM, function (event) {
        event.preventDefault();

        var $currentFilterItem = $(this);
        if (!$currentFilterItem.hasClass(CLASS_CSS_FILTER_ITEMACTIVE)) {
            var $parent = $currentFilterItem.closest("." + CLASS_JS_FILTER);
            var $filterItems = $parent.find("." + CLASS_JS_FILTERITEM);
            $filterItems.removeClass(CLASS_CSS_FILTER_ITEMACTIVE);

            $currentFilterItem.addClass(CLASS_CSS_FILTER_ITEMACTIVE);

            var type = "";
            type = $currentFilterItem.is("[" + ATTR_DATA_FILTERDEFAULT + "]") ? FILTER_ID_DEFAULT: type;
            type = $currentFilterItem.is("[" + ATTR_DATA_FILTEREXTENDED + "]") ? FILTER_ID_EXTENDED : type;

            var $gallery = $currentFilterItem.closest("." + CLASS_JS_GALLERY);

            handleFiltersItem($gallery, type);
        }
    });
    $(document).on("click", "." + CLASS_JS_CLOSE, function () {
        var $anchor = $(this);
        var $gallery = $anchor.closest("." + CLASS_JS_GALLERY);
        closeGallery($gallery);
    });
    $(document).on("click", "." + CLASS_JS_OPEN, function (event) {
        event.preventDefault();
        var $anchor = $(this);
        var gallerySelector = $anchor.attr(ATTR_DATA_GALLERYSELECTOR) || $anchor.attr("href");
        var $gallery = global.getElementsBySelector(gallerySelector, $anchor);
        $gallery.trigger(EVENT_GALLERY_BEFOREOPEN);
        $gallery.removeClass(CLASS_CSS_HIDDEN);
        $gallery.each(initializeGallery);
        setThumbnailsMargin($gallery);
        var thumbnailIndex = parseInt($anchor.attr(ATTR_DATA_THUMBNAILINDEX), 10) || 0;
        var $filterItems = $gallery.find("." + CLASS_JS_FILTERITEM);
        if (thumbnailIndex > -1) {
            setTimeout(function () {
                $filterItems.first().trigger("click");
                $gallery.find("." + CLASS_JS_THUMBNAIL_WRAPPER + ":eq(" + thumbnailIndex +") ." + CLASS_JS_THUMBNAIL).trigger("click");
                $gallery.trigger(EVENT_GALLERY_AFTEROPEN);
            }, 0);
        }
    });
    $(document).on(EVENT_GALLERY_AFTEROPEN, "." + CLASS_JS_GALLERY, function () {
        var $gallery = $(this);
        if (!$gallery.is("[data-gallery-map]")) {
            var $thumbnailItems = $gallery.find("." + CLASS_JS_THUMBNAIL_ITEMS);
            var $anchorWrapper = $thumbnailItems.find("." + CLASS_JS_THUMBNAIL_ITEMACTIVE);
            if (!$anchorWrapper.length) {
                $anchorWrapper = $thumbnailItems.find("." + CLASS_JS_THUMBNAIL_WRAPPER).first();
            }
            $anchorWrapper.addClass(CLASS_JS_THUMBNAIL_ITEMACTIVE + " " + CLASS_CSS_THUMBNAIL_ITEMACTIVE);
            var $anchor = $anchorWrapper.find("." + CLASS_JS_THUMBNAIL).first();

            $anchor.trigger("click");
            setActiveBarPosition($gallery, $anchor, $anchorWrapper);
            $gallery.find(".js-lazyLoad").each(function () {
                var $lazyItem = $(this);
                $lazyItem.removeClass("js-lazyLoad");
                $lazyItem.attr("src", $lazyItem.attr("data-lazy-src"));
            });
        } else {
            $gallery.find(".js-lazyLoad").trigger("force-load");
        }
    });
    $(window).on("resize", function () {
        clearTimeout(global.resizeTimeout);
        global.resizeTimeout = setTimeout(function () {
            $("." + CLASS_JS_GALLERY).each(initializeGallery);
        }, DELAY_INITIALIZE_AFTERRESIZE);
    });
    $(document).on("keyup", function (event) {
        var keyCode = event.keyCode;
        if (keyCode === KEYCODE_ARROWLEFT || keyCode === KEYCODE_ARROWRIGHT) {
            var $visibleGallery = $("." + CLASS_JS_GALLERY + ":visible");
            var $controls = $visibleGallery.find("." + CLASS_JS_CONTROL);
            var $galleryLeftArrow = $controls.filter("." + CLASS_JS_CONTROL_PREVIOUS + ":visible");
            var $galleryRightArrow = $controls.filter("." + CLASS_JS_CONTROL_NEXT + ":visible");

            clearTimeout(global.arrowAnimateTimeout);
            switch (keyCode) {
                case KEYCODE_ARROWLEFT:
                    $galleryRightArrow.removeClass(CLASS_CSS_FAKEHOVER);
                    $galleryLeftArrow.addClass(CLASS_CSS_FAKEHOVER);
                    $galleryLeftArrow.trigger("click");
                break;
                case KEYCODE_ARROWRIGHT:
                    $galleryLeftArrow.removeClass(CLASS_CSS_FAKEHOVER);
                    $galleryRightArrow.addClass(CLASS_CSS_FAKEHOVER);
                    $galleryRightArrow.trigger("click");
                break;
            }
            global.arrowAnimateTimeout = setTimeout(function () {
                $controls.removeClass(CLASS_CSS_FAKEHOVER);
            }, ANIMATIONS_DURATION);
        }
        if (keyCode == KEYCODE_ESC) {
            var $galleries = $("." + CLASS_JS_GALLERY + "[" + ATTR_DATA_CLOSE + "]");
            closeGallery($galleries);
        }
    });


    /**
     * initialize
     * */
    $("." + CLASS_JS_GALLERY + ":not(." + CLASS_JS_INITIALIZED + ")").each(initializeGallery);
    $("." + CLASS_JS_GENERATED).each(generateGallery);
    var galleryTimeoutId = 0;
    $(document).on("ajax-loaded", function () {
        clearTimeout(galleryTimeoutId);
        galleryTimeoutId = setTimeout(function () {
            $("." + CLASS_JS_GALLERY + ":not(." + CLASS_JS_INITIALIZED + ")").each(initializeGallery);
            $("." + CLASS_JS_GENERATED + ":not(." + CLASS_JS_INITIALIZED_GENERATED + ")").each(generateGallery);
        }, 500);
    })


})(jQuery, globalWrapper.fshr);
